import { SaveResult } from '../../core/saveResult';
import { Rule } from '../rules/models/rule';
import { rulePrecedenceDirection } from './directives/rulesDialog/models/rulePrecedenceDirectionEnum';

export class RulesService 
{
    static $inject = ['$http'];

    constructor(private _$http: angular.IHttpService

    ) {


    }

    public getAllRules(): Promise<Array<Rule>> {
        return new Promise<any>((resolve, reject) => {
            this._$http.get('/Rules/getAllRules')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const rules = response.data.map(s => new Rule(s));
                    resolve(rules);
                });
        });
    }

    public getAllActiveRules(): Promise<Array<Rule>> {
        return new Promise<any>((resolve, reject) => {
            this._$http.get('/Rules/getAllActiveRules')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const rules = response.data.map(s => new Rule(s));
                    resolve(rules);
                });
        });
    }

    public getRuleById(ruleId: number): Promise<Rule> {
        if (ruleId == null) { //New Rule
            ruleId = 0;
        }
        return new Promise<any>((resolve, reject) => {
            this._$http.get<Rule>(`/Rules/getRuleById/${ruleId}`, { ruleId } as ng.IRequestShortcutConfig)
                .then((response) => {
                    const rule = new Rule(response.data);
                    resolve(rule);
                });
        });
    }

    public add(ruleModel: Rule): Promise<SaveResult> {
        return new Promise<SaveResult>((resolve, reject) => {           
            this._$http.post<SaveResult>(`/Rules/createRule`, ruleModel.toJson())
                .then(
                    (response: angular.IHttpPromiseCallbackArg<SaveResult>) => {
                        const result = response.data;
                        resolve(result);
                    })
                .catch(
                    (response: angular.IHttpPromiseCallbackArg<SaveResult>) => {
                        reject(response);
                    });
        });
    }

    public update(ruleModel: Rule): Promise<SaveResult> {
        return new Promise<SaveResult>((resolve, reject) => {
            this._$http.post<SaveResult>(`/Rules/updateRule`, ruleModel.toJson())
                .then(
                    (response: angular.IHttpPromiseCallbackArg<SaveResult>) => {
                        const result = response.data;
                        resolve(result);
                    })
                .catch(
                    (response: angular.IHttpPromiseCallbackArg<SaveResult>) => {
                        reject(response);
                    });
        });
    }

    public deleteRule(ruleId: number): Promise<any> {
        /*alert("start delete " + ruleId);*/
        return new Promise<any>((resolve, reject) => {
            this._$http.delete(`/Rules/deleteRule/${ruleId}`, { ruleId } as ng.IRequestShortcutConfig)
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const saveResult = response.data;
                    resolve(saveResult);
                })
                .catch(
                    (response: angular.IHttpPromiseCallbackArg<any>) => {
                        reject(response.data);
                    });
        });
    }

    public moveRulePrecedence(ruleId: number, direction: rulePrecedenceDirection): Promise<any> {
        /*alert("start precedence " + ruleId);*/
        const url = `/Rules/moveRulePrecedence?ruleId=${ruleId}&direction=${direction}`;

        var request = {
            method: 'POST',
            url: url, // Include query parameters in the URL
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };
        return new Promise<any>((resolve, reject) => {
            this._$http(request)
                .then(
                    (response: any) => {
                        resolve(response.data);
                    })
                .catch(
                    (response: any) => {
                        reject(response.data);
                    });          
        });

    }

    public getOriginCities(): Promise<Array<any>> {
        return new Promise<any>((resolve, reject) => {
            this._$http.get('/Rules/getOriginCities')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const cities = response.data.map(s => s);
                    resolve(cities);
                });
        });
    }

    public getRegionCodes(): Promise<Array<any>> {
        return new Promise<any>((resolve, reject) => {
            this._$http.get('/Rules/getRegionCodes')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const cities = response.data.map(s => s);
                    resolve(cities);
                });
        });
    }

    public getOriginLocations(): Promise<Array<any>> {
        return new Promise<any>((resolve, reject) => {
            this._$http.get('/Rules/getOriginLocations')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const locations = response.data.map(s => s);
                    resolve(locations);
                });
        });
    }


}

angular
    .module('deliveryCreate.app')
    .service('rulesService', RulesService);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/rulesService.ts
 **/